export const optionsRu = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  timezone: "UTC",
};

export const date = new Date().toLocaleString("ru", optionsRu);
